<!-- 能耗预警界面 -->
<template>
  <div class="access-record-container">
    <el-tabs v-model="activeName" @tab-click="handleTabClick">
      <el-tab-pane label="能耗告警记录" name="first">
        <!--主页面 -->
        <div class="flex-row" style="height: 100%">
          <div class="flex-auto flex-valign" style="overflow: hidden">
            <!-- 右侧表格 -->
            <div class="section-main_table">
              <ioc-table ref="energyTable" :data="energyAlarmTableData" :option="energyAlarmTableOption"
                :page="energyPage" @row-cancle="closeDialog" @search-change="searchEnergyResult"
                @search-reset="resetEnergyQuery" @current-change="selectEnergyPage" @size-change="changeEnergySize"
                @selection-change="handleEnergySelectionChange">
                <!-- 表格搜索条件 自定义 -->
                <!-- 类型 -->
                <template slot="search_buildId">
                  <div>
                    <el-select v-model="alarmSearchParams.buildId" placeholder="请选择">
                      <el-option v-for="item in buildNameOptions" :key="item.value" :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </template>
                <!-- 自定义操作列 -->
                <template slot="menu" slot-scope="scope">
                  <el-tooltip class="item" effect="dark" content="通知" placement="top" popper-class="tooltip-draw">
                    <el-button type="text" icon="el-icon-message" @click="handleView(scope.row, scope.index)"></el-button>
                  </el-tooltip>
                </template>
              </ioc-table>
            </div>
          </div>
        </div>
      </el-tab-pane>

      <el-tab-pane label="谷峰平预警记录" name="second">
        <!--主页面 -->
        <div class="flex-row" style="height: 100%">
          <div class="flex-auto flex-valign" style="overflow: hidden">
            <!-- 右侧表格 -->
            <div class="section-main_table">
              <ioc-table ref="accessTab" :data="tableData" :option="tableOption" :page="page" @row-cancle="closeDialog"
                @search-change="searchResult" @search-reset="resetQuery" @current-change="selectPage"
                @size-change="changeSize" @selection-change="handleSelectionChange">
                <!-- 类型 -->
                <template slot="search_buildId">
                  <div>
                    <el-select v-model="warnSearchParams.buildId" placeholder="请选择">
                      <el-option v-for="item in buildNameOptions" :key="item.value" :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </template>
                <!-- 自定义操作列 -->
                <template slot="menu" slot-scope="scope">
                  <el-tooltip class="item" effect="dark" content="通知" placement="top" popper-class="tooltip-draw">
                    <el-button type="text" icon="el-icon-message" @click="handleView(scope.row, scope.index)"></el-button>
                  </el-tooltip>
                </template>
              </ioc-table>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-dialog title="添加执行组" :visible.sync="dialogVisible" width="550px" height="500px" :destroy-on-close="true"
      v-dialogDrag append-to-body>
      <work-group-tree ref="workGroupTree" :multiCheck="true" @groupData="getGroupData"
        :showPercentage="false"></work-group-tree>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="handleCancel">取消</el-button>
        <el-button type="primary" @click="handleConfirm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { api } from "../api/index";
import utils from "@src/common/utils";
import { guFengPingAlarmOption as tableOption } from "../config/guFengPingAlarmTable";
import { energyConstAlarmOption as energyAlarmTableOption } from "../config/energyConstAlarmTable";
import workGroupTree from "@src/modules/realTimeAlarm/components/workGroupTree";

export default {
  components: { workGroupTree },
  data() {
    return {
      groupData: [],
      dialogVisible: false,
      activeName: "first",
      // 能耗预警
      energyAlarmTableOption: energyAlarmTableOption(),
      energyPage: {
        currentPage: 1,
        total: 10,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      energyAlarmTableData: [],
      energySearchParams: {
        buildName: "",
        hlName: "",
      },
      // 能耗预警 新增/修改
      checkedEnergyAlarmIds: [],
      // 新增/修改表格
      energySubLoading: false,
      energyTitle: "",
      showAddOrEditEnergyAlarm: false,

      // 谷峰平预警
      tableOption: tableOption(),
      page: {
        currentPage: 1,
        total: 10,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      tableData: [],
      searchParams: {
        buildId: "",
      },

      // 选择的id
      checkedGfpAlarmIds: [],
      buildNameOptions: [],
      alarmSearchParams: {
        buildId: ''
      },
      warnSearchParams: {
        buildId: ''
      }
    };
  },
  mounted() {
    this.queryBuildList();
    this.getList();
    this.getEnergyList();
  },
  beforeDestroy() { },
  methods: {
    handleCancel() {
      this.dialogVisible = false;
      this.groupData = [];
    },
    async handleConfirm() {
      const { success } = await this.$fetch(api.alarm.sendMessage, {

      })
      if (success) {
        this.$message.success('发送成功！')
      } else {
        this.$message.error('发送失败！')
      }
    },
    getGroupData(data) {
      console.info('data', data)
      this.groupData = [...data];
    },
    async queryBuildList() {
      const { success, returnObj } = await this.$fetch(api.display.getBuildList)
      if (success) {
        this.buildNameOptions = returnObj.map(v => {
          return {
            label: v.name,
            value: v.id
          }
        })
      }
    },
    handleTabClick(tab, event) {
      console.log("--handleTabClick:--", tab, event);
    },

    // TODO获取列表
    getList() {
      this.$fetch(api.alarm.queryEnergyConsumptionVfpAlarmList, {
        // ...this.searchParams,
        buildId: this.warnSearchParams.buildId,
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize
      }).then(res => {
        if (res.success) {
          this.tableData = res.returnObj.list;
          this.page.total = res.returnObj.total;
        }
      })
    },
    // 获取能耗列表
    getEnergyList() {
      this.$fetch(api.alarm.queryEnergyConsumptionAlarmList, {
        // ...this.energySearchParams,
        buildId: this.alarmSearchParams.buildId,
        warningName: this.energySearchParams.warningName,
        pageNum: this.energyPage.currentPage,
        pageSize: this.energyPage.pageSize
      }).then(res => {
        if (res.success) {
          this.energyAlarmTableData = res.returnObj.list;
          this.energyPage.total = res.returnObj.total;
        }
      })
    },

    closeDialog() { },

    // 能耗预警相关
    searchEnergyResult(param) {
      console.log("---能耗查询--param:--", param);
      this.energySearchParams = param;
      console.log("--energySearchParams:--", this.energySearchParams);
      this.energyPage.currentPage = 1;
      this.getEnergyList();
    },
    // 重置按钮
    resetEnergyQuery() {
      console.log("---重置----", this.energySearchParams);
      this.energySearchParams.buildId = "";
      this.alarmSearchParams.buildId = ""
      this.energySearchParams.warningName = "";
      this.getEnergyList();
    },
    // 点击上一页下一页按钮
    selectEnergyPage(val) {
      this.energyPage.currentPage = val;
      this.getEnergyList();
    },
    // 修改每页数据数量
    changeEnergySize(val) {
      this.energyPage.currentPage = 1;
      this.energyPage.pageSize = val;
      this.getEnergyList();
    },
    handleEnergySelectionChange(items) {
      console.log("---select--items:--", items);

      if (!items || !items.length) {
        this.checkedGfpAlarmIds = [];
      } else {
        this.checkedGfpAlarmIds = items.map((item) => {
          return item.id;
        });
      }
      console.log("----this.checkedGfpAlarmIds:---", this.checkedGfpAlarmIds);
    },

    // 查询按钮事件
    searchResult(param) {
      console.log("---查询--param:--", param);
      this.searchParams = param;
      console.log("---查询--this.searchParams:--", this.searchParams);
      this.page.currentPage = 1;
      this.getList();
    },
    // 重置按钮
    resetQuery() {
      console.log("---重置--this.searchParams:--", this.searchParams);
      this.searchParams.buildId = "";
      this.searchParams.warningName = "";
      this.warnSearchParams.buildId = "";
      this.getList();
    },
    // 点击上一页下一页按钮
    selectPage(val) {
      this.page.currentPage = val;
      this.getList();
    },
    // 修改每页数据数量
    changeSize(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.getList();
    },
    handleSelectionChange(items) { },
    // 详情操作
    handleView(row, index) {
      this.dialogVisible = true
    },
    //关闭详情
    handleClosePanel() { },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-tabs__content {
  width: 100%;
  height: 82vh;
}

::v-deep .el-tab-pane {
  height: 100%;
}

.panel-content {
  .content-top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .info-item {
    margin: 15px 0px;
    // width: 50%;
  }

  .item-img {
    margin: 15px 0px;
  }

  .label {
    padding: 0 20px;
    width: 100px;
    text-align: center;
  }

  .detail-info {
    width: 100%;
    padding: 0 40px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    flex-wrap: wrap;
  }
}

.access-record-container {
  width: 100%;
  height: 100%;

  .el-table__fixed-right-patch {
    display: none;
  }

  .el-dialog {

    .el-date-editor.el-input,
    .el-date-editor.el-input__inner {
      width: 260px;
    }
  }
}

.car-info-box {
  ::v-deep .el-form-item--small.el-form-item {
    margin-bottom: 18px;
    display: flex;
    width: 100%;

    .el-form-item__content {
      flex: 1;
    }
  }
}

.question-box {
  ::v-deep .el-form-item__content {
    width: 80%;
  }

  ::v-deep .el-select {
    width: 100%;
  }

  .ques-type-box {
    display: flex;

    ::v-deep .el-form-item__content {
      display: flex;
    }

    .desc {
      width: 155px;
      margin-left: 5px;
    }

    ::v-deep .el-select {
      width: 0px;
      flex: 1;
    }
  }

  ::v-deep .el-range-editor--small.el-input__inner {
    width: 95%;
  }

  ::v-deep .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 37vw;
  }
}

.question-detail-box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .detail-chart-box {
    width: 100%;
    height: 220px;
    display: flex;
    flex-direction: row;

    .chart-left-box {
      width: 280px;
      height: 220px;
      border: 1px solid white;
      border-radius: 10px;

      // flex: 1;
      .left-content-box {
        display: flex;
        flex-direction: row;
        align-items: center;
        height: calc(100% - 42px);
      }
    }

    .chart-right-box {
      width: calc(100% - 320px);
      margin-left: 40px;
      height: 220px;
      border: 1px solid white;
      border-radius: 10px;
    }
  }

  .detail-table-box {
    width: 100%;
    height: calc(100% - 220px);
  }
}
</style>

<style scoped>
::v-deep.el-picker-panel {
  width: 37vw;
}

::v-deep .el-date-picker .el-picker-panel__content {
  width: 34vw;
}

::v-deep .el-tabs__nav-wrap::after {
  background-color: #c0c4cc;
}
</style>
